module.exports = __webpack_public_path__ + "img/DE00428.6294644b.png";